<template>
    <div class="sizey props-group">
        <el-form-item label="显示行数">
          <el-input  type="number" v-model="component.properties.numberOfLines" min="1" max="5"/>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'attr-sizey',
  props: ['component'],
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style>
  .sizey{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/sizey.vue